import discardNullableValues from '@haaretz/s-common-utils/discardNullableValues';
import fetchUtility from '@haaretz/s-fetch-utility';
import mergeURLSearchParams from '@haaretz/s-navigation-utils/mergeURLSearchParams';
import { useMutation } from '@tanstack/react-query';
export default function useClientMutation({ url, body, clientOptions, fetchOptions, searchParams, transformResponse, cacheKey, responseType = 'json', appendVariableKeysToSearchParams = [] }) {
    const isGetRequest = fetchOptions?.method === 'GET';
    const fetchSearchParam = mergeURLSearchParams(body ? new URLSearchParams(discardNullableValues(body)) : undefined, searchParams, {
        mergeMethod: 'set'
    });
    return useMutation({
        mutationKey: [
            'all',
            cacheKey,
            url,
            fetchSearchParam?.toString(),
            ...body === undefined ? [] : [
                body
            ]
        ].filter(Boolean),
        mutationFn: async (mutationBody)=>{
            const variablesInSearchParams = isGetRequest ? mutationBody : Object.fromEntries(Object.entries(mutationBody ?? {}).filter(([key])=>appendVariableKeysToSearchParams.includes(key)));
            const fetchSearchParamMerged = mergeURLSearchParams(Object.keys(variablesInSearchParams ?? {}).length > 0 ? new URLSearchParams(discardNullableValues(variablesInSearchParams)) : undefined, fetchSearchParam, {
                mergeMethod: 'set'
            });
            const result = await fetchUtility({
                url,
                searchParams: fetchSearchParamMerged,
                headers: fetchOptions?.headers ? {
                    ...fetchOptions.headers
                } : {},
                ...isGetRequest ? {
                    method: 'GET'
                } : {
                    method: 'POST',
                    body: mutationBody || body
                },
                options: {
                    cache: 'no-cache'
                },
                responseType
            })({});
            return transformResponse ? transformResponse(result) : result;
        },
        throwOnError: false,
        ...clientOptions
    });
}

//# sourceMappingURL=useClientMutation.js.map